import MadmaxPixiLayer from "./MadmaxPixiLayer";
import {injectable} from "inversify";

@injectable()
class PixiLayers extends MadmaxPixiLayer {

    constructor() {
        super();
    }

    create(name:string) {
        return this.addLayer(name, new MadmaxPixiLayer());
    }
}

export default PixiLayers;
